import { UnifiedThemeProvider } from '@backstage/theme';
import DarkIcon from '@material-ui/icons/Brightness2';
import LightIcon from '@material-ui/icons/WbSunny';
import { itgDarkTheme, itgLightTheme } from './itgTheme';
import './itg.css';

export const themes = [
  {
    id: 'itg-light',
    title: 'ITG Light',
    variant: 'light' as const,
    icon: <LightIcon />,
    Provider: ({ children }: { children: React.ReactNode }) => (
      <UnifiedThemeProvider theme={itgLightTheme} themeName="itg">
        {children}
      </UnifiedThemeProvider>
    ),
  },
  {
    id: 'itg-dark',
    title: 'ITG Dark',
    variant: 'dark' as const,
    icon: <DarkIcon />,
    Provider: ({ children }: { children: React.ReactNode }) => (
      <UnifiedThemeProvider theme={itgDarkTheme} themeName="itg">
        {children}
      </UnifiedThemeProvider>
    ),
  },
];
